import duxFactory from './fetch-dux-factory';
import * as api from '../api/api';

export default {
  postLogin: duxFactory({
    apiFn: api.postLogin,
    actionPrefix: 'POST_LOGIN',
    successListeners: [
      'POST_ADDRESS',
      'PUT_ADDRESS',
      'POST_CARD',
      'PUT_CARD',
      'PUT_BIRTHDAY',
      'POST_VALIDATE_LOGIN',
      'POST_LOGOUT',
      'POST_EMAIL_PREF',
      'DEL_ADDRESS',
      'DEL_CARD',
      'POST_NAME_AND_EMAIL',
      'CANCEL_MEMBERSHIP',
      'SWITCH_CLUB_MEMBERSHIP',
      'DELETE_WAITLIST',
      'POST_SECONDARY_CONTACT',
      'PATCH_SECONDARY_CONTACT'
    ]
  }),
  postLogout: duxFactory({
    apiFn: api.postLogout,
    actionPrefix: 'POST_LOGOUT'
  }),
  validateLogin: duxFactory({
    apiFn: api.validateLogin,
    persist: true,
    actionPrefix: 'POST_VALIDATE_LOGIN'
  }),
  postSignUp: duxFactory({
    apiFn: api.postSignUp,
    actionPrefix: 'POST_SIGN_UP'
  }),
  getShopProducts: duxFactory({
    apiFn: api.getShopProducts,
    actionPrefix: 'GET_SHOP_PRODUCTS'
  }),
  getShopProductBySlug: duxFactory({
    apiFn: api.getShopProductBySlug,
    actionPrefix: 'GET_SHOP_PRODUCTS_BY_SLUG'
  }),
  postAddress: duxFactory({
    apiFn: api.postAddress,
    actionPrefix: 'POST_ADDRESS'
  }),
  putAddress: duxFactory({
    apiFn: api.putAddress,
    actionPrefix: 'PUT_ADDRESS'
  }),
  postCard: duxFactory({
    apiFn: api.postCard,
    actionPrefix: 'POST_CARD'
  }),
  putCard: duxFactory({
    apiFn: api.putCard,
    actionPrefix: 'PUT_CARD'
  }),
  putBirthday: duxFactory({
    apiFn: api.putBirthday,
    actionPrefix: 'PUT_BIRTHDAY'
  }),
  putPassword: duxFactory({
    apiFn: api.putPassword,
    actionPrefix: 'PUT_PASSWORD'
  }),
  postAddToCart: duxFactory({
    apiFn: api.postAddToCart,
    actionPrefix: 'POST_ADD_TO_CART'
  }),
  getCart: duxFactory({
    apiFn: api.getCart,
    actionPrefix: 'GET_CART',
    // persist: true,
    successListeners: [
      'POST_ADD_TO_CART',
      'POST_CART_SHIPPING',
      'POST_CART_BILLING',
      'DELETE_CART_ITEM',
      'PUT_CART_ITEM',
      'POST_PROMO_CODE',
      'DEL_PROMO_CODE'
    ]
  }),
  postCartShipping: duxFactory({
    apiFn: api.postCartShipping,
    actionPrefix: 'POST_CART_SHIPPING',
    successEmit: ['CLOSE_MODAL']
  }),
  getCartShipping: duxFactory({
    apiFn: api.getCartShipping,
    actionPrefix: 'GET_CART_SHIPPING',
    requestListeners: [
      'POST_CART_SHIPPING'
    ]
  }),
  postCartBilling: duxFactory({
    apiFn: api.postCartBilling,
    actionPrefix: 'POST_CART_BILLING'
  }),
  getCartBilling: duxFactory({
    apiFn: api.getCartBilling,
    actionPrefix: 'GET_CART_BILLING',
    requestListeners: [
      'POST_CART_BILLING'
    ]
  }),
  getLookups: duxFactory({
    apiFn: api.getLookups,
    actionPrefix: 'GET_LOOKUPS'
  }),
  deleteCartItem: duxFactory({
    apiFn: api.deleteCartItem,
    actionPrefix: 'DELETE_CART_ITEM'
  }),
  putCartItem: duxFactory({
    apiFn: api.putCartItem,
    actionPrefix: 'PUT_CART_ITEM'
  }),
  getOrder: duxFactory({
    apiFn: api.getOrder,
    actionPrefix: 'GET_ORDER',
    successListeners: [
      'POST_COMPLETE_ORDER'
    ]
  }),
  postCompleteOrder: duxFactory({
    apiFn: api.postCompleteOrder,
    actionPrefix: 'POST_COMPLETE_ORDER'
  }),
  postValidateAddress: duxFactory({
    apiFn: api.postValidateAddress,
    actionPrefix: 'POST_VALIDATE_ADDRESS'
  }),
  postPromoCode: duxFactory({
    apiFn: api.postPromoCode,
    actionPrefix: 'POST_PROMO_CODE'
  }),
  delPromoCode: duxFactory({
    apiFn: api.delPromoCode,
    actionPrefix: 'DEL_PROMO_CODE'
  }),
  postEmailPref: duxFactory({
    apiFn: api.postEmailPref,
    actionPrefix: 'POST_EMAIL_PREF'
  }),
  postStayInLoop: duxFactory({
    apiFn: api.postStayInLoop,
    actionPrefix: 'POST_STAY_LOOP'
  }),
  postVerifyAccount: duxFactory({
    apiFn: api.postVerifyAccount,
    actionPrefix: 'POST_VERIFY_ACCOUNT'
  }),
  postForgotPassword: duxFactory({
    apiFn: api.postForgotPassword,
    actionPrefix: 'POST_FORGOT_PASSWORD'
  }),
  postVerifyForgotPasswordToken: duxFactory({
    apiFn: api.postVerifyForgotPasswordToken,
    actionPrefix: 'POST_VERIFY_FORGOT_PASSWORD_TOKEN'
  }),
  postResetPassword: duxFactory({
    apiFn: api.postResetPassword,
    actionPrefix: 'POST_RESET_PASSWORD'
  }),
  deleteAddress: duxFactory({
    apiFn: api.deleteAddress,
    actionPrefix: 'DEL_ADDRESS'
  }),
  deleteCard: duxFactory({
    apiFn: api.deleteCard,
    actionPrefix: 'DEL_CARD'
  }),
  postNameAndEmail: duxFactory({
    apiFn: api.postNameAndEmail,
    actionPrefix: 'POST_NAME_AND_EMAIL'
  }),
  postSecondaryContact: duxFactory({
    apiFn: api.postSecondaryContact,
    actionPrefix: 'POST_SECONDARY_CONTACT'
  }),
  patchSecondaryContact: duxFactory({
    apiFn: api.patchSecondaryContact,
    actionPrefix: 'PATCH_SECONDARY_CONTACT'
  }),
  getOrderHistory: duxFactory({
    apiFn: api.getOrderHistory,
    actionPrefix: 'GET_ORDER_HISTORY'
  }),

  //club
  getClubById: duxFactory({
    apiFn: api.getClubById,
    actionPrefix: 'GET_CLUB_BY_ID'
  }),

  getClubDisableTypes: duxFactory({
    apiFn: api.getClubDisableTypes,
    actionPrefix: 'GET_CLUB_DISABLE_TYPES'
  }),

  cancelMembership: duxFactory({
    apiFn: api.cancelMembership,
    actionPrefix: 'CANCEL_MEMBERSHIP',
    successEmit: ['CLOSE_MODAL']
  }),

  joinWaitList: duxFactory({
    apiFn: api.joinWaitList,
    actionPrefix: 'JOIN_WAIT_LIST'
  }),

  acceptInvitation: duxFactory({
    apiFn: api.acceptInvitation,
    actionPrefix: 'ACCEPT_INVITATION'
  }),

  getUserWaitListStatus: duxFactory({
    apiFn: api.getUserWaitListStatus,
    actionPrefix: 'GET_USER_WAITLIST_STATUS'
  }),

  createClubMembershipCart: duxFactory({
    apiFn: api.createClubMembershipCart,
    actionPrefix: 'CREATE_CLUB_MEMBERSHIP_CART'
  }),

  switchClubMembership: duxFactory({
    apiFn: api.switchClubMembership,
    actionPrefix: 'SWITCH_CLUB_MEMBERSHIP'
  }),

  deleteWaitlist: duxFactory({
    apiFn: api.deleteWaitlist,
    actionPrefix: 'DELETE_WAITLIST'
  }),
  getAddressSuggestions: duxFactory({
    apiFn: api.getAddressSuggestions,
    actionPrefix: 'GET_ADDRESS_SUGGESTIONS'
  }),
};
